function formatTime(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12;  // The hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;  // Add leading zero to minutes if necessary

  return `${hours}:${minutes} ${ampm}`;
}


function renderTrackHisytory(trackingDetails) {
  const data = trackingDetails.trackingHistory;
  const timeZone = trackingDetails.fromAddressTimeZone;
  // const shippingMethod = trackingDetails.shippingMethod;
  // const trackingCode = trackingDetails.trackingCode;
  // let trackingService = '';
  // let deliveryMethod = '';
  // let trackingServiceUrl = '';
  // let deliveryServiceMark = '';
  
  // console.log(shippingMethod);
  

  // switch (shippingMethod) {
  //   case "DHL.EXPRESS.WORLDWIDE":
  //     trackingService = "DHL Express";
  //     deliveryMethod = "Express worldwide shipping";
  //     trackingServiceUrl = "https://www.dhl.com/us-en/home/tracking.html?tracking-id="+ trackingCode;
  //     deliveryServiceMark = "https://tracker.flexport.com/build/_assets/DHL-SD3JAA7W.svg";
  //     break;
    
  //   case "LASERSHIP.ROUTED.DELIVERY":
  //     trackingService = "LaserShip";
  //     deliveryMethod = "Routed delivery shipping";
  //     trackingServiceUrl = "https://www.lasership.com/track.php?track_number_input="+ trackingCode;
  //     deliveryServiceMark = "https://tracker.flexport.com/build/_assets/Lasership-OVSK6GVE.svg";
  //     break;

  //   case "UPS.EXPEDITED.MAILINNOVATIONS.LIGHTWEIGHT":
  //       trackingService = "UPS";
  //       deliveryMethod = "Expedited mailinnovations lightweight shipping";
  //       trackingServiceUrl = "https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums="+ trackingCode;
  //       deliveryServiceMark = "https://tracker.flexport.com/build/_assets/UPS-EMHQ47RM.svg";
  //       break;
      
  // }

  // console.log('renderTrackHisytory:', data);
  let _html = '';
  let lastDate = '';
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  let cnt = 0;

  data.forEach((item) => {
    const eventTime = new Date(item.eventTime);
    const changedTime = eventTime.toLocaleString('en-US', {
      timeZone: timeZone,
    });
    // console.log(new Date(changedTime));
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: 'long',  // Full month name
      day: 'numeric', // Day as a number
    }).format(new Date(changedTime));
    lastMessage = item.message;
    lastDate = days[eventTime.getDay()] + ', ' + formattedDate;
  });

  data.reverse().forEach((item) => {

    const eventTime = new Date(item.eventTime);
    const changedTime = eventTime.toLocaleString('en-US', {
      timeZone: timeZone,
    });
    // console.log(new Date(changedTime));
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: 'long',  // Full month name
      day: 'numeric', // Day as a number
    }).format(new Date(changedTime));
    const formattedTime = formatTime(new Date(changedTime));

    let contentHtml = `
      <div class="flex justify-between ${cnt > 3 ? ' hide-block' : ''}">
        <div class="w-6 pt-1">
            <div class="relative z-10 flex justify-center w-2 h-2 mx-auto rounded-full">

      
        ${cnt == 0 ? `<div
                  class="absolute inline-flex w-3 h-3 rounded-full opacity-75 animate-ping bg-[rgb(0,160,172)] scale-150"
                ></div>`: ''}

              <div
                class="absolute flex justify-center h-2 w-2 bg-[rgb(0,160,172)] rounded-full z-10 mx-auto top-[3px]"
              ></div>
              </div>
              <div
                class="flex justify-center h-full bg-[rgb(0,160,172)] w-[2px] mx-auto mt-[3px]"
              ></div>
        </div>
        <div class="w-[95%]">
          <div class="flex justify-between w-full pb-4">
            <div class="h-full">
              <p class="text-[14px] text-gray-800 font-bold">${item.message}</p>
              <p class="text-[14px] text-[rgba(109,113,117,1)]" id="address">
                ${item.location.city ? item.location.city : ''}
                ${item.location.city && item.location.country ? ", " : ''}
                ${item.location.country ? item.location.country : ''}
              </p>
            </div>
            <div class="h-full pl-2">
              <p
                class="text-[14px] block text-gray-800 font-bold text-right text-nowrap"
              >
                ${formattedDate}
              </p>
              <p
                class="text-[14px] right-0 text-right text-[rgba(109,113,117,1)]"
              >
                ${formattedTime}
              </p>
            </div>
          </div>
          <hr class="w-full pb-4" />
        </div>
      </div>`;
    _html += contentHtml;
    cnt++;
  });

  _html += `
          <div class="relative flex md:gap-[15px]" id="toggle-show" onclick="onClickToggle(${cnt})" collapsed="true">
            <div class="w-6 pt-1 mt-[3px]">
              <div class=" flex justify-center h-2 w-2 mx-auto bg-[rgb(0,160,172)] rounded-[50%]"></div>
            </div>
            <p class="text-[14px] text-gray-800 font-bold cursor-pointer" id="toggle-text">Show previous ${cnt - 4} updates</p>
          </div>`;

  document.getElementById('timeline').innerHTML = _html;
  document.getElementById('last-date').innerText = lastDate;
  // document.getElementById('tracking-service').innerText = "Track via " + trackingService;
  // document.getElementById('delivery-service').innerText = "Delivery by " + trackingService;
  // document.getElementById('shipping-method').innerText = deliveryMethod;
  // document.getElementById('tracking-service').href = trackingServiceUrl;
  // document.getElementById('tracking-code').innerText = trackingCode;
  // document.getElementById('delivery-service-mark').value = deliveryServiceMark;
  // document.getElementById('delivery-service-mark').innerHTML = 
  // `<img class="rounded-[50%]" src=${deliveryServiceMark} alt="service-mark" width="40" height="40" />`;
}
